namespace $ { export class $piterjs_place_page extends $mol_page {

	/**
	 *  ```
	 *  place $piterjs_place
	 *  ```
	 **/
	@ $mol_mem
	place() {
		return (( obj )=>{
			return obj
		})( new this.$.$piterjs_place(  ) )
	}

	/**
	 *  ```
	 *  title \
	 *  ```
	 **/
	title() {
		return ""
	}

	/**
	 *  ```
	 *  tools / <= Close
	 *  ```
	 **/
	tools() {
		return [this.Close()] as readonly any[]
	}

	/**
	 *  ```
	 *  Close $mol_link
	 *  	arg * place null
	 *  	sub / <= Close_icon
	 *  ```
	 **/
	@ $mol_mem
	Close() {
		return (( obj )=>{
			obj.arg = () => ({
			"place" :  null as any ,
		})
			obj.sub = () => [this.Close_icon()] as readonly any[]
			return obj
		})( new this.$.$mol_link(  ) )
	}

	/**
	 *  ```
	 *  Close_icon $mol_icon_cross
	 *  ```
	 **/
	@ $mol_mem
	Close_icon() {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_icon_cross(  ) )
	}

	/**
	 *  ```
	 *  body /
	 *  	<= Info
	 *  	<= Map
	 *  ```
	 **/
	body() {
		return [this.Info() , this.Map()] as readonly any[]
	}

	/**
	 *  ```
	 *  Info $mol_view sub <= info
	 *  ```
	 **/
	@ $mol_mem
	Info() {
		return (( obj )=>{
			obj.sub = () => this.info()
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  info /
	 *  	<= Address
	 *  	<= Route
	 *  ```
	 **/
	info() {
		return [this.Address() , this.Route()] as readonly any[]
	}

	/**
	 *  ```
	 *  Address $mol_view sub / <= address
	 *  ```
	 **/
	@ $mol_mem
	Address() {
		return (( obj )=>{
			obj.sub = () => [this.address()] as readonly any[]
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  address \
	 *  ```
	 **/
	address() {
		return ""
	}

	/**
	 *  ```
	 *  Route $mol_view sub / <= route
	 *  ```
	 **/
	@ $mol_mem
	Route() {
		return (( obj )=>{
			obj.sub = () => [this.route()] as readonly any[]
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  route \
	 *  ```
	 **/
	route() {
		return ""
	}

	/**
	 *  ```
	 *  Map $mol_map_yandex
	 *  	zoom?val <=> zoom?val
	 *  	objects / <= Mark
	 *  ```
	 **/
	@ $mol_mem
	Map() {
		return (( obj )=>{
			obj.zoom = ( val? : any ) => this.zoom( val )
			obj.objects = () => [this.Mark()] as readonly any[]
			return obj
		})( new this.$.$mol_map_yandex(  ) )
	}

	/**
	 *  ```
	 *  zoom?val 14
	 *  ```
	 **/
	@ $mol_mem
	zoom( val? : any , force? : $mol_mem_force ) {
		return ( val !== void 0 ) ? val : 14
	}

	/**
	 *  ```
	 *  Mark $mol_map_yandex_mark
	 *  	pos <= coords
	 *  	title \
	 *  ```
	 **/
	@ $mol_mem
	Mark() {
		return (( obj )=>{
			obj.pos = () => this.coords()
			obj.title = () => ""
			return obj
		})( new this.$.$mol_map_yandex_mark(  ) )
	}

	/**
	 *  ```
	 *  coords $mol_vector_2d /
	 *  	0
	 *  	0
	 *  ```
	 **/
	@ $mol_mem
	coords() {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_vector_2d( 0 , 0 ) )
	}

} }
